<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="PaNotifyManageFilter" :model="PaNotifyManage" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="标题" prop="formFilter.title">
          <el-input class="filter-item" v-model="PaNotifyManage.formFilter.title"
            :clearable="true" placeholder="标题"
          />
        </el-form-item>
        <el-form-item label="类型" prop="formFilter.type">
          <el-select class="filter-item" v-model="PaNotifyManage.formFilter.type" :clearable="true" filterable
            placeholder="类型" :loading="PaNotifyManage.type.impl.loading"
            @visible-change="PaNotifyManage.type.impl.onVisibleChange"
            @change="onTypeValueChange">
            <el-option v-for="item in PaNotifyManage.type.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="formFilter.content">
          <el-input class="filter-item" v-model="PaNotifyManage.formFilter.content"
            :clearable="true" placeholder="内容"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetPaNotifyManage">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshPaNotifyManage(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-form ref="PaNotifyManage" :model="formData" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="16" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>公告列表</span>
              <div class="base-card-operation">
                <el-button @click="onAddPaNotifyClick()" type="primary" :size="defaultFormItemSize"
                  :disabled="!checkPermCodeExist('PaNotifyManage:PaNotifyManage:AddPaNotify')">
                  添加
                </el-button>
              </div>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paNotify" :data="PaNotifyManage.PaNotify.impl.dataList" :size="defaultFormItemSize" @sort-change="PaNotifyManage.PaNotify.impl.onSortChange"
                  header-cell-class-name="table-header-gray" height="550px"
                  highlight-current-row @current-change="PaNotifyManage.PaNotify.impl.currentRowChange" row-key="id" @row-click="handleRowClick"
                >
                  <el-table-column type="selection" width="55px"></el-table-column>
                  <el-table-column label="序号" align="center" type="index" width="55px" :index="PaNotifyManage.PaNotify.impl.getTableIndex" />
                  <el-table-column label="标题" align="center" prop="title" width="150px">
                  </el-table-column>
                  <el-table-column label="启用" align="center" prop="statusDictMap.name">
                  </el-table-column>
                  <el-table-column label="类型" align="center" prop="typeDictMap.name">
                  </el-table-column>
                  <el-table-column label="内容" align="center" prop="content" width="250px">
                  </el-table-column>
                  <el-table-column label="附件" align="center" min-width="180px">
                    <template slot-scope="scope">
                      <a v-for="item in parseUploadData(scope.row.attachmentUrl, {id: scope.row.id, fieldName: 'attachmentUrl', asImage: false})"
                        :key="item.url" href="javascript:void(0);" @click="downloadFile(item.url, item.name)">{{item.name}};</a>
                    </template>
                  </el-table-column>
                  <el-table-column label="链接" prop="linkUrl"  width="350px">
                  </el-table-column>
                  <el-table-column label="发布开始时间" prop="releaseStartTime" align="center" width="150px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.releaseStartTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="发布结束时间" prop="releaseEndTime"  align="center" width="150px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.releaseEndTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="创建人" prop="createUserIdDictMap.name" align="center">
                  </el-table-column>
                  <el-table-column label="创建时间" prop="createTime" align="center" width="100px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.createTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" fixed="right" align="center" width="90px">
                    <template slot-scope="scope">
                      <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                        :disabled="!checkPermCodeExist('PaNotifyManage:PaNotifyManage:delete')">
                        删除
                      </el-button>
                      <el-button @click.stop="onEditPaNotifyClick(scope.row)" type="text" :size="defaultFormItemSize"
                                 :disabled="!checkPermCodeExist('PaNotifyManage:PaNotifyManage:EditPaNotify')">
                        编辑
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-row type="flex" justify="end" style="margin-top: 10px;">
                  <el-pagination
                    :total="PaNotifyManage.PaNotify.impl.totalCount"
                    :current-page="PaNotifyManage.PaNotify.impl.currentPage"
                    :page-size="PaNotifyManage.PaNotify.impl.pageSize"
                    :page-sizes="[10, 20, 50, 100]"
                    layout="total, prev, pager, next, sizes"
                    @current-change="PaNotifyManage.PaNotify.impl.onCurrentPageChange"
                    @size-change="PaNotifyManage.PaNotify.impl.onPageSizeChange">
                  </el-pagination>
                </el-row>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="8" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>接收人列表</span>
              <div class="base-card-operation">
                <el-button @click="onSelectUserClick()" type="primary" :size="defaultFormItemSize"
                  :disabled="this.PaNotifyManage.PaNotify.impl.currentRow == null||!checkPermCodeExist('PaNotifyManage:PaNotifyManage:SelectUser')">
                  添加人员
                </el-button>
              </div>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paNotifyLine" :data="PaNotifyManage.PaNotifyLine.impl.dataList" :size="defaultFormItemSize" @sort-change="PaNotifyManage.PaNotifyLine.impl.onSortChange"
                  header-cell-class-name="table-header-gray" height="550px"
                >
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="PaNotifyManage.PaNotifyLine.impl.getTableIndex" />
                  <el-table-column label="部门名称" align="center" prop="deptName">
                  </el-table-column>
                  <el-table-column label="接收人姓名" align="center" prop="userName">
                  </el-table-column>
                  <el-table-column label="状态" align="center" prop="statusDictMap.name">
                  </el-table-column>
                  <el-table-column label="回复内容" align="center" prop="reply">
                  </el-table-column>
                  <el-table-column label="更新时间" align="center" prop="updateTime" width="100px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.updateTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center" fixed="right" width="50px">
                    <template slot-scope="scope">
                      <el-button @click.stop="onDeleteLineClick(scope.row)" type="text" :size="defaultFormItemSize"
                        :disabled="!checkPermCodeExist('PaNotifyManage:PaNotifyManage:deleteLine')">
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import {PaNotifyController, PaNotifyLineController, DictionaryController, SysUserController} from '@/api';
import editPaNotify from '@/views/PaNotify/editPaNotify.vue';
import selectUser from '@/views/UserInfo/selectUser.vue';
import addPaNotify from '@/views/PaNotify/addPaNotify.vue';

export default {
  name: 'PaNotifyManage',
  props: {
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      formData: {
        PaNotify: {
          id: undefined,
          title: undefined,
          status: undefined,
          type: undefined,
          content: undefined,
          attachmentUrl: undefined,
          linkUrl: undefined,
          releaseStartTime: undefined,
          releaseEndTime: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          paNotifyLine: {
          },
          isDatasourceInit: false
        }
      },
      PaNotifyManage: {
        formFilter: {
          title: undefined,
          type: undefined,
          content: undefined
        },
        formFilterCopy: {
          title: undefined,
          type: undefined,
          content: undefined
        },
        PaNotify: {
          impl: new TableWidget(this.loadPaNotifyWidgetData, this.loadPaNotifyVerify, true, true, 'id', 0)
        },
        PaNotifyLine: {
          impl: new TableWidget(this.loadPaNotifyLineWidgetData, this.loadPaNotifyLineVerify, false, false, 'userName', 1)
        },
        type: {
          impl: new DropdownWidget(this.loadTypeDropdownList)
        },
        PaNotifyListDiv: {
          isInit: false
        },
        PaNotifyLinListDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      if (this.selectedRow !== row) {
        this.selectedRow = row;
        this.$refs.paNotify.clearSelection();
      }
      this.$refs.paNotify.toggleRowSelection(row);
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetPaNotifyManage () {
      this.$refs.PaNotifyManageFilter.resetFields();
      this.refreshPaNotifyManage(true);
    },
    /**
     * 公告通知数据获取函数，返回Promise
     */
    loadPaNotifyWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        paNotifyDtoFilter: {
          title: this.PaNotifyManage.formFilterCopy.title,
          type: this.PaNotifyManage.formFilterCopy.type,
          content: this.PaNotifyManage.formFilterCopy.content
        }
      }
      return new Promise((resolve, reject) => {
        PaNotifyController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.PaNotifyManage.PaNotify.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.PaNotifyManage.PaNotify.impl.currentRow.id, 'id');
              this.$refs.paNotify.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 公告通知数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaNotifyVerify () {
      this.PaNotifyManage.formFilterCopy.title = this.PaNotifyManage.formFilter.title;
      this.PaNotifyManage.formFilterCopy.type = this.PaNotifyManage.formFilter.type;
      this.PaNotifyManage.formFilterCopy.content = this.PaNotifyManage.formFilter.content;
      return true;
    },
    /**
     * 公告通知行数据获取函数，返回Promise
     */
    loadPaNotifyLineWidgetData () {
      if (!this.PaNotifyManage.PaNotify.impl.currentRow) {
        return;
      }
      let params = {paNotifyLineDtoFilter: {paNotifyId: this.PaNotifyManage.PaNotify.impl.currentRow.id}};
      return new Promise((resolve, reject) => {
        PaNotifyLineController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 公告通知行数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaNotifyLineVerify () {
      return true;
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_notify_type'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeValueChange (value) {
    },
    /**
     * 更新公告列表
     */
    refreshPaNotifyListDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.PaNotifyManage.PaNotify.impl.refreshTable(true, 1);
      } else {
        this.PaNotifyManage.PaNotify.impl.refreshTable();
      }
      this.PaNotifyManage.PaNotifyListDiv.isInit = true;
    },
    /**
     * 更新接收人列表
     */
    refreshPaNotifyLinListDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.PaNotifyManage.PaNotifyLine.impl.refreshTable(true, 1);
      } else {
        this.PaNotifyManage.PaNotifyLine.impl.refreshTable();
      }
      this.PaNotifyManage.PaNotifyLinListDiv.isInit = true;
    },
    /**
     * 更新公告管理
     */
    refreshPaNotifyManage (reloadData = false) {
      if (reloadData) {
        this.PaNotifyManage.PaNotify.impl.refreshTable(true, 1);
      } else {
        this.PaNotifyManage.PaNotify.impl.refreshTable();
      }
      if (reloadData) {
        this.PaNotifyManage.PaNotifyLine.impl.refreshTable(true, 1);
      } else {
        this.PaNotifyManage.PaNotifyLine.impl.refreshTable();
      }
      if (!this.PaNotifyManage.isInit) {
        // 初始化下拉数据
      }
      this.PaNotifyManage.isInit = true;
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      this.$confirm('是否删除?').then(res => {
        PaNotifyController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.PaNotifyManage.PaNotify.impl.refreshTable();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 删除
     */
    onDeleteLineClick (row) {
      this.$refs.PaNotifyManage.validate((valid) => {
        if (!valid) return;
        this.$confirm('是否删除?').then(res => {
          this.PaNotifyManage.PaNotifyLine.impl.dataList = this.PaNotifyManage.PaNotifyLine.impl.dataList.filter(item => {
            return item.__cascade_add_temp_id__ !== row.__cascade_add_temp_id__;
          });
        }).catch(e => {});
      });
    },
    /**
     * 添加人员
     */
    onSelectUserClick () {
      let params = {};
      let that = this;
      this.$dialog.show('添加人员', selectUser, {
        area: '1100px', offset: '10px'
      }, params).then(res => {
        if (res.length === 0) {
          return;
        }
        for (let i = 0; i < res.length; i++) {
          res[i].userName = res[i].showName;
          res[i].deptName = res[i].deptIdDictMap.name;
        }
        let row = that.PaNotifyManage.PaNotify.impl.currentRow;
        PaNotifyController.addLines(this, {paNotifyDto: row, paNotifyLineDtoList: res}).then(res => {
          this.refreshPaNotifyLinListDivWidget();
        });
      }).catch(e => {});
    },
    /**
     * 添加
     */
    onAddPaNotifyClick () {
      let params = {};

      this.$dialog.show('添加', addPaNotify, {
        area: '1000px'
      }, params).then(res => {
        this.refreshPaNotifyListDivWidget();
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onEditPaNotifyClick (row) {
      let params = {
        id: row.id
      };

      this.$dialog.show('编辑', editPaNotify, {
        area: '1000px'
      }, params).then(res => {
        this.PaNotifyManage.PaNotify.impl.refreshTable();
      }).catch(e => {});
    },
    onResume () {
      this.refreshPaNotifyManage(true);
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaNotify: {
          id: undefined,
          title: undefined,
          status: undefined,
          type: undefined,
          content: undefined,
          attachmentUrl: undefined,
          linkUrl: undefined,
          releaseStartTime: undefined,
          releaseEndTime: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          paNotifyLine: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshPaNotifyManage();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
    'PaNotifyManage.PaNotify.impl.currentRow': {
      handler (newValue) {
        this.PaNotifyManage.PaNotifyLine.impl.refreshTable(true, 1);
      },
      immediate: true
    }
  }
}
</script>
